export const CoreSonarObjectsOptimisticChangeName = 'CoreSonarObjectsOptimisticChange';
